import Tabs from 'react-bootstrap/Tabs';
import React from "react";
import Tab from 'react-bootstrap/Tab';
import MyDeviceInfo from "../../components/reusable-components/myDevice-Info";
function MyIQOSTab() {
    return (
        <div>
            {/* Tabs Start */}
            <div style={{
                font: 'Sintony',
                fontSize: '12px',
                lineHeight: '18.24px',
                color: '#475666',
                textAlign: 'center',
                fontWeight: '400',
                // marginLeft: '40px'
            }}>
                <Tabs fill
                    defaultActiveKey="home"
                    transition={false}
                    id="noanim-tab-example"
                    className="mb-3"
                >
                    <Tab eventKey="home" title="MY IQOS" style={{
                        font: 'Sintony',
                        fontSize: '14px',
                        lineHeight: '18.24px',
                        color: '#475666',
                        textAlign: 'center',
                        fontWeight: '700',
                        marginBottom: '40px',
                        marginTop: '40px',
                        marginLeft: '10px'
                    }}>



                        <MyDeviceInfo />

                    </Tab>
                    <Tab eventKey="profile" title="COMMUNITY" style={{
                        font: 'Sintony',
                        fontSize: '12px',
                        lineHeight: '18.24px',
                        color: '#475666',
                        textAlign: 'center',
                        fontWeight: '400',
                        marginLeft: '40px !important'
                    }}>
                        <div>COMMUNITY TAB CHECK</div>
                    </Tab>
                </Tabs>
            </div>
        </div>
    );

}

export default MyIQOSTab;